// Separator used to build a stable composite key for one editable leaf
// (a single patient's completion of a single intervention group within a plan).
// Safe because all three parts are UUIDs, which never contain this character.
export const ECONOMICS_KEY_SEPARATOR = '|';

// Longest reason accepted for a reimbursement override. Mirrors the backend's
// @Size(max = 500) on EconomicsChangeEntry.note — keep the two in step.
export const REIMBURSEMENT_NOTE_MAX_LENGTH = 500;

// Excel export: Danish-style cell formats and column widths (in characters).
export const ECONOMICS_EXPORT_NUMBER_FORMAT = '#,##0.00';
// Whole numbers (week numbers) must never render with decimals — "uge 37,0" is wrong.
export const ECONOMICS_EXPORT_INTEGER_FORMAT = '0';
export const ECONOMICS_EXPORT_DATE_FORMAT = 'dd.mm.yyyy';
export const ECONOMICS_EXPORT_FILE_PREFIX = 'Opkraevning';
export const ECONOMICS_EXPORT_SHEET_NAME_MAX_LENGTH = 31;
export const ECONOMICS_EXPORT_COLUMN_WIDTHS = {
  planName: 24,
  patientName: 26,
  cprNumber: 13,
  moduleName: 26,
  weekNumber: 6,
  startDate: 12,
  endDate: 12,
  amount: 14,
  isOverridden: 11,
  note: 40,
  completedAt: 13
} as const;
